import React from "react"
import PropTypes from "prop-types"
import axios from "axios"
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
// import DatePicker from "react-datepicker";
import moment from "moment"
// import "react-datepicker/dist/react-datepicker.css";
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import MomentLocaleUtils, {
  formatDate,
  parseDate,
} from 'react-day-picker/moment';

import { DatePicker, KeyboardDatePicker,MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';

import "moment/locale/fr";

moment.locale("fr");
const choosedate = (date)=>{
  if(date.day() == 6 || date.day()==0){
    return true
  }else{
    return false
  }
}

class Disponibilites extends React.Component {
  constructor(props) {
    super(props);
    this.addDate= this.addDate.bind(this)
    this.choosedate= this.choosedate.bind(this)
    this.changeDisponibilite= this.changeDisponibilite.bind(this)
    this.validateBTN= this.validateBTN.bind(this)
    this.submitBTN= this.submitBTN.bind(this)
    this.validate= this.validate.bind(this)
    this.state= {
      heure_block: 2,
      bien_id: "",
      type: "",
      date: moment().add(5,"days"),
      dates: [],
      allDates: []
    }
  }
  componentDidMount(){

  }
  choosedate(date){
  if(date.day() == 6 || date.day()==0 ||this.state.allDates.includes(date.format("DD-MM-YYYY"))){
    return true
  }else{
    return false
  }
}
  submitBTN(){
    if(this.state.dates.length >2){
      return(
        <div>
          <a href="" onClick={this.validate} className="btn btn-large"><i className="material-icons left">send</i>Valider</a>
        </div>
      )
    }else{
      return(
        <div>
          <a href="" className="btn btn-large disabled"><i className="material-icons left">send</i>Valider</a>
        </div>
        )
    }

  }
  validateBTN(){
      return (
        <div className="col s6">
          <div className="row">
           <div className="col s6">
            {this.state.allDates.includes(this.state.date.format("DD-MM-YYYY")) ? (
               <a href="" className="btn btn-large disabled">Ajouter </a>
              ) : (
               <a href="" className="btn btn-large" onClick={this.addDate}>Ajouter</a>
              )}
            </div>
            <div className="col s6">
            {this.submitBTN()}
            </div>
          </div>
        </div>
        )
  }
  validate(e){
    e.preventDefault()
    axios.post("/proprietaires/rdv/submit",{dates: this.state.dates,donnees: this.props.donnees,date_entree_vigueur: this.props.date}).then((data)=>{
      window.location.replace("/proprietaires/rdv")
    })
  }
  changeDisponibilite(e){
    e.preventDefault()
    let index = e.target.dataset.index
    let hour = parseInt(e.target.dataset.hour)
    let newArray = this.state.dates
    for (var i = 0; i <this.state.heure_block; i++) {
      newArray[index].possibilites[(hour+i)] = !newArray[index].possibilites[(hour+i)]
    }
    this.setState({dates: newArray})
  }
  addDate(e){
    e.preventDefault()
    this.setState({date: moment().add(5,"days"),allDates: [...this.state.allDates,this.state.date.format("DD-MM-YYYY")],dates: [...this.state.dates,{date: this.state.date,possibilites: new Array((19-9)).fill(true)}]})
  }
  render () {
      moment.locale("fr")
      const heures = Array.from(new Array((19-9)/this.state.heure_block),(val,index)=>index*this.state.heure_block)
      return (
        <React.Fragment>
        <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale={"fr"}>
          <div className="container">
          <p>Veuillez remplir vos disponibilites, minimum 3 dates.
            <br/>
            veuillez remplir le plus d'heures libres afin de nous permettre de bien nous organiser
          </p>

          </div>
          <div className="row container">
            <div className="col s6">
               <DatePicker
                variant="inline"
                label="Date"
                autoOk
                value={this.state.date}
                format="DD-MM-YYYY"
                disablePast={true}
                shouldDisableDate={this.choosedate}
                minDate={moment().add(2,"days")}
                onChange={(date)=>this.setState({date: date})}
                />
            </div>
            {this.validateBTN()}
          </div>
          <table>
            <tbody>
              <tr>
                <th>Jour</th>
                {Array.from(Array(19-9).keys()).map((i,n)=>(
                  <th key={(i+9)}>{(i+9)}:00</th>
                  ))}

              </tr>
            </tbody>
             {this.state.dates.map((date,index)=>(
                <tr key={index}>
                  <th>{moment(date.date,'DD/MM/YYYY',true).format("DD-MM-YYYY")}</th>
                  {/*{date.possibilites.map((etat,heure)=>(
                      <td key={heure+9} colSpan={this.state.heure_block}>
                      <a href="" onClick={this.changeDisponibilite} data-index={index} data-hour={heure} data-date={date} className={"line line-"+(etat==true ? "green" : "red")}>&nbsp;</a>
                      </td>
                    ))} */}
                    {heures.map((heure)=>(
                      <td key={heure+9} colSpan={this.state.heure_block}>
                      <a href="" onClick={this.changeDisponibilite} data-index={index} data-hour={heure} data-date={date} className={"line line-"+(date.possibilites[heure]==true ? "green" : "red")}>&nbsp;</a>

                      </td>
                    ))}
                </tr>
              ))}
          </table>
        </MuiPickersUtilsProvider>
        <ToastContainer
          position="top-right"
          autoClose={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange={false}
          draggable={false}
          />

        </React.Fragment>
      );
  }
}

export default Disponibilites
